<marv-select 
    [label]="this.labelSelect" 
    [icon]="this.iconSelect" 
    [formName]="this.formName" 
    [items]="this.items" 
    [multiple]="this.multiple"
    [displayItemsColors]="true"
    [displayItemsSelected]="this.displayItemsSelected"
    [errorText]="this.errorText"
    [withSpeechToText]="this.withSpeechToText"
></marv-select>